import React from "react";
import PropTypes from "prop-types";
import SwapCard from "./swap-card";

import { GoArrowLeft, GoArrowRight } from "react-icons/go";

const SwapScrollview = ({ data, handleItemClick }) => {
  const slideLeft = () => {
    var slider = document.getElementById("swiper");
    slider.scrollLeft = slider.scrollLeft - 300;
  };

  const slideRight = () => {
    var slider = document.getElementById("swiper");
    slider.scrollLeft = slider.scrollLeft + 300;
  };

  return (
    <>
      <div className="relative w-[300px] md:w-[690px] mx-auto">
        {data.length > 1 && (
          <>
            <button 
              className="absolute left-[-15px] md:left-[-20px] top-1/2 transform -translate-y-1/2 z-10 bg-white rounded-full p-1 shadow-md"
              onClick={slideLeft}
            >
              <GoArrowLeft
                className="text-gray-600 cursor-pointer hover:text-gray-800"
                size={24}
              />
            </button>
            <button 
              className="absolute right-[-15px] md:right-[-20px] top-1/2 transform -translate-y-1/2 z-10 bg-white rounded-full p-1 shadow-md"
              onClick={slideRight}
            >
              <GoArrowRight
                className="text-gray-600 cursor-pointer hover:text-gray-800"
                size={24}
              />
            </button>
          </>
        )}
        <div
          id="swiper"
          className="hide-scrollbars w-full flex items-start gap-4 overflow-x-auto snap-x snap-mandatory scroll-smooth"
        >
          {data.map((item, index) => {
            return (
              <div
                key={index}
                onClick={(e) => {
                  // Only trigger if the click is directly on this element, not bubbled from children
                  if (e.currentTarget === e.target) {
                    handleItemClick(item);
                  }
                }}
                className="snap-start flex flex-col flex-1 flex-shrink-0 w-[300px] min-w-[300px] md:w-[320px] md:min-w-[320px]"
              >
                <SwapCard item={item} itemClick={handleItemClick} />
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

SwapScrollview.propTypes = {
  data: PropTypes.array,
  handleItemClick: PropTypes.func,
};

export default SwapScrollview;
